export default {
  button: 'min-w-[100px] bg-[#E7ECF2]',
  active: 'bg-[white] rounded',
  text: 'm-[4px] px-[20px] py-[8px]  flex flex-col items-stretch font-interMedium text-[14px] ',
};
